/**
 * Roles and permissions.
 *
 * Permissions are checked on the server for every request. The UI also reads
 * them, but only to decide what to render -- hiding a button is not access
 * control, and the server never trusts the client's view of a role.
 */
export const ROLES = ['ADMIN', 'RECORD_OFFICER', 'ISSUE_OFFICER', 'VIEWER'];
export const PERMISSIONS = [
    'file:read',
    'file:create',
    'file:update',
    'file:import',
    'file:relocate',
    'movement:issue',
    'movement:return',
    'user:read',
    'user:manage',
    'report:read',
    'audit:read',
];
const VIEWER = ['file:read'];
const ISSUE_OFFICER = [
    ...VIEWER,
    'movement:issue',
    'movement:return',
    'report:read',
];
const RECORD_OFFICER = [
    ...VIEWER,
    'file:create',
    'file:update',
    'file:import',
    'file:relocate',
    'report:read',
];
const ADMIN = [...PERMISSIONS];
export const ROLE_PERMISSIONS = {
    ADMIN,
    RECORD_OFFICER,
    ISSUE_OFFICER,
    VIEWER,
};
export function roleHas(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
export const ROLE_LABELS = {
    ADMIN: { en: 'Administrator', hi: 'प्रशासक' },
    RECORD_OFFICER: { en: 'Record Officer', hi: 'अभिलेख अधिकारी' },
    ISSUE_OFFICER: { en: 'Issue Officer', hi: 'निर्गम अधिकारी' },
    VIEWER: { en: 'Viewer', hi: 'अवलोकनकर्ता' },
};
